import { flowRight as compose } from 'lodash';
import queries from '~lib/common/queries/EffectChain';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';

import CaseMedicationEffectChain from './CaseMedicationEffectChain.vue';

const enhance = compose(
  dataView({ queries: {
    fetchById: queries.fetchById,
    save: queries.save,
    add: queries.save
  }, dontFetchOnLoad: true }),
  renameProps({ itemData: 'customEffectChain' }),
  renameProps({ loadingItemId: 'loadingCustomEffectChain' }),
);

export default enhance(CaseMedicationEffectChain);
